import React from 'react';
import { Bar } from 'react-chartjs-2';
import { FileText } from 'react-feather';

function Inventory() {
  // DMVIC Certificate inventory data for different insurance companies
  const certificateData = [
    {
      company: 'Sunlam Insurance',
      typeA: 92,
      typeB: 87,
      typeC: 78,
      typeD: 85,
      typeE: 90
    },
    {
      company: 'HomeGuard Insurers',
      typeA: 88,
      typeB: 82,
      typeC: 75,
      typeD: 80,
      typeE: 86
    },
    {
      company: 'LifeSecure Ltd',
      typeA: 85,
      typeB: 79,
      typeC: 72,
      typeD: 77,
      typeE: 83
    },
    {
      company: 'MediCare Partners',
      typeA: 90,
      typeB: 85,
      typeC: 80,
      typeD: 82,
      typeE: 88
    },
    {
      company: 'Kenya Insurance Co',
      typeA: 83,
      typeB: 78,
      typeC: 70,
      typeD: 75,
      typeE: 81
    },
    {
      company: 'CoverMax Assurance',
      typeA: 87,
      typeB: 84,
      typeC: 76,
      typeD: 79,
      typeE: 85
    }
  ];

  const colors = ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6'];

  // Data for the main grouped bar chart
  const mainChartData = {
    labels: certificateData.map(item => item.company),
    datasets: [
      {
        label: 'Type A',
        data: certificateData.map(item => item.typeA),
        backgroundColor: colors[0],
        borderColor: colors[0],
        borderWidth: 1,
      },
      {
        label: 'Type B',
        data: certificateData.map(item => item.typeB),
        backgroundColor: colors[1],
        borderColor: colors[1],
        borderWidth: 1,
      },
      {
        label: 'Type C',
        data: certificateData.map(item => item.typeC),
        backgroundColor: colors[2],
        borderColor: colors[2],
        borderWidth: 1,
      },
      {
        label: 'Type D',
        data: certificateData.map(item => item.typeD),
        backgroundColor: colors[3],
        borderColor: colors[3],
        borderWidth: 1,
      },
      {
        label: 'Type E',
        data: certificateData.map(item => item.typeE),
        backgroundColor: colors[4],
        borderColor: colors[4],
        borderWidth: 1,
      },
    ],
  };

  const mainChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      position: 'top',
    },
    tooltips: {
      enabled: true,
    },
    scales: {
      xAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: 'Insurance Company',
          },
          ticks: {
            maxRotation: 45,
            minRotation: 45,
          },
        },
      ],
      yAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: 'Certificate Inventory (%)',
          },
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
  };

  return (
    <div className="min-vh-100" style={
        { borderRadius: "12PX", background: "#ffffff",   padding:"2rem"}
      }>
      {/* Header */}
      <div className="#bg-white border-bottom">
        <div className="container py-4">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h1 className="h3 font-weight-bold text-dark">DMVIC Certificate Inventory</h1>
              <p className="text-muted mt-1">Distribution & Management Vendor Inventory Control - Insurance Companies Kenya</p>
            </div>
          </div>
        </div>
      </div>

      <div className="container py-5">
        {/* Summary Cards */}
        <div className="row row-cols-1 row-cols-md-5 g-4 mb-5">
          {['Type A', 'Type B', 'Type C', 'Type D', 'Type E'].map((type, index) => {
            const total = certificateData.reduce((sum, item) => sum + item[type.toLowerCase().replace(' ', '')], 0);
            const average = (total / certificateData.length).toFixed(1);
            return (
              <div key={index} className="col">
                <div className="card h-100 shadow-sm border-0">
                  <div className="card-body d-flex align-items-center justify-content-between">
                    <div>
                      <h6 className="card-subtitle mb-2 text-muted">{type} Certificate Inventory</h6>
                      <h5 className="card-title font-weight-bold text-dark">{average}%</h5>
                      <p className="card-text text-muted small">Average Level</p>
                    </div>
                    <div
                      className="d-flex align-items-center justify-content-center rounded-circle p-3"
                      style={{ backgroundColor: colors[index], width: '48px', height: '48px' }}
                    >
                      <FileText className="text-white" size={24} />
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Bar Chart Views */}
        <div className="mt-5">
          {/* Main Grouped Bar Chart */}
          <div className="card shadow-sm border-0 mb-5">
            <div className="card-body">
              <h3 className="card-title font-weight-bold text-dark mb-4">Certificate Inventory Levels by Insurance Company</h3>
              <div style={{ height: '400px' }}>
                <Bar data={mainChartData} options={mainChartOptions} />
              </div>
            </div>
          </div>

          {/* Individual Company Bar Charts */}
          <div className="row row-cols-1 row-cols-lg-2 g-4">
            {certificateData.map((company, index) => {
              const companyChartData = {
                labels: ['Type A', 'Type B', 'Type C', 'Type D', 'Type E'],
                datasets: [
                  {
                    label: company.company,
                    data: [
                      company.typeA,
                      company.typeB,
                      company.typeC,
                      company.typeD,
                      company.typeE,
                    ],
                    backgroundColor: colors[index % colors.length],
                    borderColor: colors[index % colors.length],
                    borderWidth: 1,
                  },
                ],
              };

              const companyChartOptions = {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                  display: false,
                },
                tooltips: {
                  enabled: true,
                },
                scales: {
                  xAxes: [
                    {
                      scaleLabel: {
                        display: true,
                        labelString: 'Certificate Type',
                      },
                    },
                  ],
                  yAxes: [
                    {
                      scaleLabel: {
                        display: true,
                        labelString: 'Inventory (%)',
                      },
                      ticks: {
                        beginAtZero: true,
                      },
                    },
                  ],
                },
              };

              return (
                <div key={index} className="col">
                  <div className="card h-100 shadow-sm border-0">
                    <div className="card-body">
                      <h4 className="card-title font-weight-bold text-dark mb-4">{company.company}</h4>
                      <div style={{ height: '250px' }}>
                        <Bar data={companyChartData} options={companyChartOptions} />
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Inventory;